import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  transaction: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "transaction",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getTransaction.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getTransaction.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      transaction: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getTransaction.rejected, (state, action) => ({
      ...state,
      loading: false,
      transaction: [],
      totalCount: 0,
    }));
    // delete pages
    builder.addCase(Act.deleteTransaction.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(Act.deleteTransaction.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      });
      builder.addCase(Act.deleteTransaction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || action.error;
      });

  },
});

export default slice;
